// Modules
import styled from "styled-components"

// Constants
import colors from "~constants/colors"

// Images
import emptyMessagesImg from "~images/empty_messages.svg"

const MessageSentContainer = styled.div`
  color: ${colors.blue1};
  text-align: center;

  > img {
    margin: 0;
  }

  > h2.title {
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 20px 0;
  }

  > p {
    margin: 0 0 40px 0;
  }
`

interface MessageSentProps {
  title: string
  message: string
}

const MessageSent = ({ title, message }: MessageSentProps) => {
  return (
    <MessageSentContainer>
      <img src={emptyMessagesImg} alt="Message sent" />

      <h2 className="title">{title}</h2>
      <p>{message}</p>
    </MessageSentContainer>
  )
}

export default MessageSent
